import {
  START_LOADING,
  END_LOADING,
  FETCH_INVENTORY_ADJUSTMENTS,
  FETCH_INVENTORY_ADJUSTMENT,
  CREATE_INVENTORY_ADJUSTMENT,
  UPDATE_INVENTORY_ADJUSTMENT,
  DELETE_INVENTORY_ADJUSTMENT
} from "../actions/constants";

const initialState = {
  isLoading: false,
  inventoryAdjustments: [],
  currentAdjustment: null,
  numberOfPages: 0,
  currentPage: 1
};

const inventoryAdjustmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    
    case END_LOADING:
      return { ...state, isLoading: false };
    
    case FETCH_INVENTORY_ADJUSTMENTS:
      return {
        ...state,
        inventoryAdjustments: action.payload.inventoryAdjustments,
        numberOfPages: action.payload.numberOfPages,
        currentPage: action.payload.currentPage
      };
    
    case FETCH_INVENTORY_ADJUSTMENT:
      return {
        ...state,
        currentAdjustment: action.payload
      };
    
    case CREATE_INVENTORY_ADJUSTMENT:
      return {
        ...state,
        inventoryAdjustments: [...state.inventoryAdjustments, action.payload]
      };
    
    case UPDATE_INVENTORY_ADJUSTMENT:
      return {
        ...state,
        inventoryAdjustments: state.inventoryAdjustments.map((adjustment) => 
          adjustment._id === action.payload._id ? action.payload : adjustment
        ),
        currentAdjustment: action.payload
      };
    
    case DELETE_INVENTORY_ADJUSTMENT:
      return {
        ...state,
        inventoryAdjustments: state.inventoryAdjustments.filter((adjustment) => adjustment._id !== action.payload),
        currentAdjustment: null
      };
    
    default:
      return state;
  }
};

export default inventoryAdjustmentsReducer;
